<template>
   <div class="baseSetup">
       <div class="scroll-box">
            <div class="tr-li">
                <div class="from-input"><el-checkbox v-model="isInputBoard" label="是否开启手写板功能" ></el-checkbox></div>
            </div>
            <div class="tr-li">
                <div class="from-input"><el-checkbox v-model="isRedCardLogin" label="是否开启读卡登录" ></el-checkbox></div>
            </div>
            <div class="tr-li">
                <div class="from-input"><el-checkbox v-model="isAuxiliaryScreen" label="是否开启副屏功能" ></el-checkbox></div>
            </div>
            <div class="tr-li">
                <div class="from-input"><el-checkbox v-model="isCallLocalSound" label="取餐叫号播放声源取本地文件" ></el-checkbox></div>
            </div>
            <div class="tip">
                注:本功能只支持WIndows版本+KDS电脑本地播报，播放文件在当前目录voice文件夹下
            </div>
            <div class="tr-li">
                <div class="from-input"><el-checkbox v-model="isPlaceOrderSelectOperator" label="中餐下单时,选择点餐员功能" ></el-checkbox></div>
            </div>
            <div class="tr-li">
                <div class="from-input"><el-checkbox v-model="isPlaceOrderBackToDeskMap" label="中餐业态,下单后直接返回桌号界面" ></el-checkbox></div>
            </div>
            <div class="tr-li">
                <div class="from-input">
                    <el-checkbox v-model="isRunAiConfirm" label="启用AI点菜确认框提示" ></el-checkbox>
                    <div class="time-box" :class="{selected:isRunAiConfirm}">,倒计时【<input-pattern pattern="number" v-model="aiConfirmAddTime" :min="0" :disabled="!isRunAiConfirm"/>】秒</div>
                </div>
            </div>
            <div class="tr-li">
                <div class="from-input"><el-checkbox v-model="isNoPrintInvoice" label="本站点结账时不打印发票二维码（账单补打时不受此控制）" ></el-checkbox></div>
            </div>
            <div class="tr-li" v-show="$webBrowser?.isMobile?.Android">
                <div class="from-input"><el-checkbox v-model="isScanCodePayShow" label="进入聚合支付界面后，直接触发主动扫码" ></el-checkbox></div>
            </div>
            <div class="tr-li">
                <div class="from-input"><el-checkbox v-model="isFastDefaultDesk" label="快餐模式下，默认桌台" ></el-checkbox></div>
            </div>
       </div>
        <div class="footer-box">
            <button class="btn" @click="back()">返回</button>
            <button class="btn selected" @click="saveConfig()">保存配置</button>
        </div>
   </div>
</template>

<script>
export default {
    name:'baseSetup',
    data(){
        return {
            /**是否开启手写板功能*/
            isInputBoard:false,
            /**是否开启读卡登录 */
            isRedCardLogin:false,
            /*是否开启副屏功能*/
            isAuxiliaryScreen:false,
            //取餐叫号播放声源取本地文件
            isCallLocalSound:false,
            /**中餐下单时,选择点餐员功能 */
            isPlaceOrderSelectOperator:false,
            /**中餐业态,下单后直接返回桌号界面 */
            isPlaceOrderBackToDeskMap:false,
            /** 启用AI点菜确认框提示 */
            isRunAiConfirm:false,
            /**倒计时 确认 秒 */
            aiConfirmAddTime:3,
            /**本站点不打印发票二维码 */
            isNoPrintInvoice:false,
            /**进入聚合支付界面后，直接触发主动扫码*/
            isScanCodePayShow:false,
            /**快餐模式下，默认桌台 */
            isFastDefaultDesk:false,
        }
    },
    mounted(){
        this.$webBrowser.getBaseSetup().then(d=>{
            if(d){
                this.isInputBoard=d.isInputBoard===true;
                this.isRedCardLogin=d.isRedCardLogin===true;
                this.isAuxiliaryScreen=d.isAuxiliaryScreen===true;
                this.isCallLocalSound=d.isCallLocalSound===true;
                this.isPlaceOrderSelectOperator=d.isPlaceOrderSelectOperator===true;
                this.isPlaceOrderBackToDeskMap=d.isPlaceOrderBackToDeskMap===true;
                this.isRunAiConfirm=d.isRunAiConfirm===true;
                this.aiConfirmAddTime=d.aiConfirmAddTime>0?d.aiConfirmAddTime:0;
                this.isNoPrintInvoice=d.isNoPrintInvoice===true;
                this.isScanCodePayShow=d.isScanCodePayShow===true;
                this.isFastDefaultDesk=d.isFastDefaultDesk===true;
            }
        })
    },
    methods:{
        /**退出 */
        back(){
            this.$emit("close");
        },
        /**保存配置 */
        saveConfig(){
            let data={
                isInputBoard:this.isInputBoard,
                isRedCardLogin:this.isRedCardLogin,
                isAuxiliaryScreen:this.isAuxiliaryScreen,
                isCallLocalSound:this.isCallLocalSound,
                isPlaceOrderSelectOperator:this.isPlaceOrderSelectOperator,
                isPlaceOrderBackToDeskMap:this.isPlaceOrderBackToDeskMap,
                isRunAiConfirm:this.isRunAiConfirm,
                aiConfirmAddTime:this.aiConfirmAddTime,
                isNoPrintInvoice:this.isNoPrintInvoice,
                isScanCodePayShow:this.isScanCodePayShow,
                isFastDefaultDesk:this.isFastDefaultDesk
            }
            this.$webBrowser.saveBaseSetup(data).then(d=>{
                if(d && d.state==0){
                    this.$global.isNoPrintInvoice=data.isNoPrintInvoice;
                    this.$global.isFastDefaultDesk=data.isFastDefaultDesk;
                    this.$message.success("保存成功");
                    if(this.isAuxiliaryScreen){
                        this.$cacheData.DeskPosconfigure().then((d)=>{
                            let PosGuestScreen={};
                            if(d){
                                PosGuestScreen.PosGuestScreen_LoopImages=d.PosGuestScreen_LoopImages;//POS副屏轮播图
                                PosGuestScreen.PosGuestScreenNotShowingBillDetail=d.PosGuestScreenNotShowingBillDetail;//关闭POS副屏显示账单明细
                                PosGuestScreen.PosGuestScreen_LoopInterval=d.PosGuestScreen_LoopInterval;//POS副屏轮播间隔，单位：秒
                            }
                            this.$webBrowser.openAuxiliaryScreen({
                                PosGuestScreen
                            });//显示副屏
                        }).catch(e=>{
                            console.log("基本配置获取失败："+e.message);
                            this.$webBrowser.openAuxiliaryScreen();//显示副屏
                        })
                        
                    }else{
                        this.$webBrowser.auxiliaryScreenClose();//关闭副屏
                    }
                }
            });
            
        }
    }
}
</script>

<style lang="scss">
@import './baseSetup.scss';
</style>